import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Check if we're in a browser environment
const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';

// Only import LanguageDetector in browser environment to avoid build-time issues
let LanguageDetector = null;
if (isBrowser) {
  LanguageDetector = require('i18next-browser-languagedetector').default;
}

const getNavigatorLanguage = () => {
  if (typeof navigator !== 'undefined' && navigator.language) return navigator.language
  return 'en_US'
}

const safeLocalStorageGet = (key) => {
  // Extra safety check for build environment
  if (!isBrowser) return null;
  if (typeof window.localStorage === 'undefined') return null;
  try {
    return window.localStorage.getItem(key)
  } catch (_e) {
    return null
  }
}

const detectionOptions = {
  order: ['querystring', 'cookie', 'navigator', 'htmlTag'],
  caches: [],
  // Explicitly disable localStorage lookup during detection
  lookupLocalStorage: undefined,
  lookupSessionStorage: undefined,
}

// Configure i18n with plugins based on environment
if (isBrowser && LanguageDetector) {
  i18n.use(LanguageDetector);
}

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'en_US',
    lng: safeLocalStorageGet('lng') || getNavigatorLanguage(),
    detection: isBrowser ? detectionOptions : undefined,
    resources: {
      en_US: {
        translations: require('./locales/en_US/translations.json'),
      },
      de: {
        translations: require('./locales/de/translations.json'),
      },
      th_TH: {
        translations: require('./locales/th_TH/translations.json'),
      },
      id: {
        translations: require('./locales/id/translations.json'),
      },
      "zh-TW": {
        translations: require('./locales/zh_TW/translations.json'),
      },
      //Added to load correctly on Android app for Taiwanese users
      zh_rTW: {
        translations: require('./locales/zh_TW/translations.json'),
      }
    },
    ns: ['translations'],
    defaultNS: 'translations',
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['b'],
    },
  });

i18n.languages = ['en_US', 'th_TH', 'id', 'de', 'zh-TW', 'zh-rTW']

export default i18n;
